// extracted by mini-css-extract-plugin
module.exports = {"compWrap":"UiTag_compWrap__363Fj","selected":"UiTag_selected__3PWcn"};